export default "__VITE_ASSET__C9fTR0pA__"